import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      padding: theme.spacing(2),
    },
    titleWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
    },
    title: {},
    subtitle: {
      ...theme.typography.regular14,
      color: COLORS.gray.gray40,
      marginBottom: theme.spacing(1),
      whiteSpace: 'pre-line',
    },
    childrenWrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
  }),
  { name: 'StaticPanel' }
);
